import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from "react";
import toastService from "Root/profile/toastService";
import TextAreaInput from "../textAreaInput/textArea";
import styles from "./style.module.scss";
const CheckboxButton = (props) => {
    const { value, freeFormValue = "", setValue, setFreeFormValue, autoNext, goNext } = props;
    // Function to handle deselecting other options
    const dis = (e) => {
        setValue([e]);
        props.setFlag(!props.deselectOtherFlag);
    };
    const removeElement = () => {
        const { answers } = props;
        // updates for retake quiz experience
        const newAnswers = answers.filter((elem) => elem !== value);
        setValue((prevState) => [...prevState].filter((elem) => elem !== value), newAnswers);
    };
    const addElement = () => {
        const { answers } = props;
        // updates for retake quiz experience
        const newAnswers = answers.concat(value);
        setValue((prevState) => prevState.concat(value), newAnswers);
        if (autoNext) {
            goNext();
        }
    };
    const clickHandler = (e) => {
        if (props.deselectOtherFlag) {
            dis(e.currentTarget.value);
            return;
        }
        if (props.deselectOther) {
            dis(e.currentTarget.value);
            return;
        }
        const deselectValues = props.deselect;
        if (deselectValues.length > 0) {
            const selectedItem = props.answers.find((item) => deselectValues.includes(item));
            // updates for retake quiz experience
            const newAnswers = [...props.answers.filter((elem) => elem !== selectedItem)];
            if (!props.answers?.includes(value)) {
                newAnswers.push(value);
            }
            setValue((_) => newAnswers, newAnswers);
            return;
        }
        if (props.answers?.includes(value)) {
            removeElement();
            e.currentTarget.checked = !e.currentTarget.checked;
        }
        else if (props.stopper) {
            if (props.answers.length < props.stopper) {
                addElement();
                e.currentTarget.checked = !e.currentTarget.checked;
            }
            else {
                toastService.errorMessage("Maximum number of selected options");
            }
        }
        else {
            addElement();
            e.currentTarget.checked = !e.currentTarget.checked;
        }
    };
    const onChangeFreeForm = (string) => {
        setFreeFormValue && setFreeFormValue(string);
    };
    const changeHandler = () => null;
    return (_jsxs("label", { htmlFor: props.labelFor || value, className: [styles.label_container, props.className].join(" "), children: [_jsx("input", { id: props.labelFor || value, type: "checkbox", value: value, onClick: clickHandler, onChange: changeHandler, name: value, checked: props.answers.includes(value) }), _jsxs("div", { className: `${styles.btn} ${props.answers.includes(value) ? styles.checked : styles.btn_unchecked} ${props.iconRaw && styles.iconbtn} ${props.answers.includes(value) && props.isFreeForm && styles.free_form}`, children: [props.iconRaw && _jsx("div", { className: styles.img_container, dangerouslySetInnerHTML: { __html: props.iconRaw } }), _jsx("div", { className: styles.label_wrapper, children: _jsx("span", { className: styles.label, children: props.text.toLocaleUpperCase() }) }), props.answers.includes(value) && props.isFreeForm && (_jsx(TextAreaInput, { setValue: onChangeFreeForm, placeholder: "Let Us Know", value: freeFormValue, extraClassName: styles.free_form_input, rows: 4, maxLength: 400 }))] })] }));
};
export default memo(CheckboxButton);
CheckboxButton.defaultProps = {
    iconRaw: "",
    stopper: 0,
};
